export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑套件',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ sampleSetStatus }) => 'Y' !== sampleSetStatus,
  },
  {
    text: that.$l('menu_text_delete') || '删除套件',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ sampleSetStatus }) => 'Y' !== sampleSetStatus,
  },
  {
    text: that.$l('menu_text_set_copy') || '复制套件',
    icon: 'el-icon-document-copy',
    menuType: 'copy',
    allow: 'C',
    disabled: ({ sampleSetStatus }) => 'S' != sampleSetStatus,
  },
  {
    text: that.$l('menu_text_audit') || '审核套件',
    icon: 'el-icon-check',
    menuType: 'audit',
    divided: true,
    allow: 'T',
    disabled: ({ sampleSetStatus }) => 'Y' !== sampleSetStatus,
  },
  {
    text: that.$l('menu_text_change') || '审核修改',
    icon: 'el-icon-edit-outline',
    menuType: 'change',
    allow: 'I',
    disabled: ({ sampleSetStatus }) => 'S' !== sampleSetStatus,
  },
  {
    text: that.$l('menu_text_rejected') || '驳回套件',
    icon: 'el-icon-close',
    menuType: 'reject',
    divided: true,
    allow: 'P',
    disabled: ({ sampleSetStatus }) => 'S' !== sampleSetStatus,
  },
]
